import { GPDEndRegistrationTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGpdLibraryFields } from "../../../schema/gpd-schema-library";

export const getGpdEndRegistrationSchema = (
  type: FormType | undefined
): SchemaForFormData<GPDEndRegistrationTask> => ({
  type: "object",
  title: `GPD-Beeindigen ${getTitleAddon(type)}`,
  description: `Dit is het GPD Beeindigen formulier. ${getDocsLinkMarkdown("GPD")}`,
  required: ["metadata"],
  properties: {
    metadata: {
      type: "object",
      required: ["projectNumber", "qualityRegime", "deliveryAccountableParty", "broId"],
      properties: pickGpdLibraryFields([
        "projectNumber",
        "qualityRegime",
        "deliveryAccountableParty",
        "broId",
      ]),
    },
  },
});
